export const BUILDER_CHROME_STORE_URL =
  'https://chrome.google.com/webstore/detail/appcues-builder';
